import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { RouterLink } from '@angular/router';
import { MatTree, MatTreeModule, MatTreeNode } from '@angular/material/tree';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../date-format';

@NgModule({
  declarations: [],
  imports: [
    NgxMaskDirective,
    NgxMaskPipe,
    ReactiveFormsModule,
    RouterLink,
    CommonModule,
    MatGridListModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatSidenavModule,
    MatDividerModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatTableModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatIconModule,
    MatCheckboxModule,
    MatTabsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatListModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
    MatDialogModule,
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    MatGridListModule,
    MatTableModule,
    MatMenuModule,
    MatTooltipModule,
    MatPaginator,
    MatSort,
    MatSortModule,
    MatInputModule,
    MatButtonModule,
    MatStepperModule,
    MatChipsModule,
    MatTreeModule,
    MatButtonToggleModule,
    MatBottomSheetModule,
    MatTreeNode, MatTree
  ],
  exports: [
    NgxMaskDirective,
    NgxMaskPipe,
    ReactiveFormsModule,
    RouterLink,
    CommonModule,
    MatStepperModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatSidenavModule,
    MatDividerModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatCheckboxModule,
    MatTabsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatSlideToggleModule,
    MatListModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
    MatDialogModule,
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    MatGridListModule,
    MatTableModule,
    MatMenuModule,
    MatTooltipModule,
    MatPaginator,
    MatSort,
    MatSortModule,
    MatChipsModule,
    MatTreeModule,
    MatButtonToggleModule,
    MatBottomSheetModule, MatTreeNode, MatTree
  ],
  providers: [provideMomentDateAdapter(MY_FORMATS)],
})
export class MaterialModule { }
